import { get } from 'lodash/fp';

const useNotEqualFilterArray = () => {
  const notEqualFilterArray = (array, key, value) => array.filter((obj) => get(key, obj) !== value);

  return notEqualFilterArray;
};

export default useNotEqualFilterArray;
